import type { IFootTrafficVisitsHistoryRecord } from '@/Interfaces/Attribution/FootTraffic.interface';
import moment from 'moment';

const DAY_MS = 24 * 60 * 60 * 1000;
const PRIOR_YEAR_DAYS = 364;
const HISTORY_YEARS = 3;

export const weekKey = (date: string | Date): string => moment(date).startOf('isoWeek').format('YYYY-MM-DD');

export const priorYearWeekKey = (date: string | Date): string =>
  moment(date).subtract(PRIOR_YEAR_DAYS, 'days').startOf('isoWeek').format('YYYY-MM-DD');

export const buildVisitsByWeek = (visitsHistory: IFootTrafficVisitsHistoryRecord[]): Map<string, number> => {
  const map = new Map<string, number>();
  for (const { weekStartDate, visits } of visitsHistory) {
    map.set(weekKey(weekStartDate), visits);
  }
  return map;
};

export const buildHistoricalAvgByWeek = (visitsHistory: IFootTrafficVisitsHistoryRecord[]): Map<string, number> => {
  const buckets = new Map<string, number[]>();
  for (const { weekStartDate, visits } of visitsHistory) {
    const t = new Date(weekStartDate).getTime();
    const offsets: number[] = [];
    for (let y = 1; y <= HISTORY_YEARS; y++) offsets.push(y * PRIOR_YEAR_DAYS);
    for (const offset of offsets) {
      const key = weekKey(new Date(t + offset * DAY_MS));
      const arr = buckets.get(key) ?? [];
      arr.push(visits);
      buckets.set(key, arr);
    }
  }
  const avg = new Map<string, number>();
  for (const [k, arr] of buckets) {
    avg.set(k, Math.round(arr.reduce((a, b) => a + b, 0) / arr.length));
  }
  return avg;
};
